import useStores from '@hooks/useStore';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { ParamsList } from '@/routes/routes.types';

export const useWorkspaceDetail = (processId: string | undefined) => {
  const { workspaceStore } = useStores();
  const workspaceId = useParams()[ParamsList.WorkspaceId] as string;

  useEffect(() => {
    if (processId && workspaceId) {
      workspaceStore.fetchWorkspace(processId, workspaceId);
    }
  }, [processId, workspaceId, workspaceStore]);

  return {
    workspace: workspaceStore.currentWorkspace,
    loading: workspaceStore.loadingWorkspace,
    workspaceId
  };
};
